import { Maybe, IShipmentIssueType } from 'types/graphqlTypes'

export const SCHEDULING_CATEGORY_ID = '5'
export const VERIFY_ADDRESS_ISSUE_ID = '138'

export const canIssueManuallyResolve = (
  issueType: Maybe<Pick<IShipmentIssueType, 'canManuallyResolve'>>
) => {
  const { canManuallyResolve } = issueType || {}

  return canManuallyResolve
}

export const isVerifyAddressIssue = (
  issueType: Maybe<Pick<IShipmentIssueType, 'categoryId' | 'id'>>
) => {
  const { categoryId, id } = issueType || {}

  return categoryId === SCHEDULING_CATEGORY_ID && id === VERIFY_ADDRESS_ISSUE_ID
}
